import { Paper, Typography } from "@firecms/ui";

import { type AdminToolReportSectionProps } from "./AdminToolReportSection.types";

const AdminToolReportSection: React.FC<AdminToolReportSectionProps> = ({ title, emptyMessage, rows, entries }) => {
  const hasRows = rows && rows.length > 0;
  const hasEntries = entries && entries.length > 0;

  if (!hasRows && !hasEntries) {
    return (
      <Paper className="flex flex-col gap-2 p-4">
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" className="text-gray-600 dark:text-gray-300">
          {emptyMessage}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper className="flex flex-col gap-3 p-4">
      <Typography variant="h6">{title}</Typography>

      {hasRows ? (
        <dl className="grid gap-2 sm:grid-cols-2">
          {rows.map((row) => (
            <div key={row.label} className="flex flex-col gap-0.5">
              <Typography variant="caption" color="secondary">
                {row.label}
              </Typography>
              <Typography variant="body2">{row.value}</Typography>
            </div>
          ))}
        </dl>
      ) : null}

      {hasEntries ? (
        <ul className="flex flex-col gap-3">
          {entries.map((entry, index) => (
            <li
              key={`${entry.primary}-${String(index)}`}
              className="border-b border-surface-200 pb-3 last:border-b-0 last:pb-0 dark:border-surface-700"
            >
              <Typography className="font-medium">{entry.primary}</Typography>
              {entry.secondary ? (
                <Typography variant="body2" className="text-gray-700 dark:text-gray-300">
                  {entry.secondary}
                </Typography>
              ) : null}
              {entry.meta ? (
                <Typography variant="caption" color="secondary">
                  {entry.meta}
                </Typography>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </Paper>
  );
};

export default AdminToolReportSection;
